import React from 'react';

import Modal from '~/components/modals/modal';
import Button from '~/components/button';
import { centsToCurrency } from '~/utils/numbers';

import modalStyles from '~/components/modals/skip-shipment/skip-shipment-modal.module.scss';
import styles from '~/components/account/settings/account-settings.module.scss';

const SkipShipmentConfirmationModal = ({
  onClose,
  isOpen,
  isFlexPay,
  shipmentNumber = '',
  shipmentDate = '',
  storeCreditValue = 0,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    className={modalStyles.skipShipmentConfirmationModal}
  >
    <Content
      onClose={onClose}
      isFlexPay={isFlexPay}
      shipmentNumber={shipmentNumber}
      shipmentDate={shipmentDate}
      storeCreditValue={storeCreditValue}
    />
  </Modal>
);

export default SkipShipmentConfirmationModal;

const Content = ({
  isFlexPay,
  shipmentNumber,
  storeCreditValue,
  shipmentDate,
  onClose,
}) => {
  return (
    <div className={modalStyles.skipShipmentContent}>
      <h3 className={styles.shipmentHistoryTextHeading}>
        Shipment{' '}
        {shipmentNumber && (
          <span className={styles.shipmentNumberPill}>{shipmentNumber}</span>
        )}
      </h3>
      {isFlexPay || storeCreditValue === 0 ? (
        <p>Your shipment for {shipmentDate}, has been successfully canceled.</p>
      ) : (
        <p>
          Your shipment for {shipmentDate}, has been successfully canceled for{' '}
          {centsToCurrency(storeCreditValue)} in store credit. This credit will
          automatically be applied to your next purchase.
        </p>
      )}
      <div className={modalStyles.buttonWrapper}>
        <Button fullWidth onClick={onClose}>
          Done
        </Button>
      </div>
    </div>
  );
};
